<form name="form" #formLeftParadeRing="ngForm" class="stewards-modal">
  <div class="modal-header stewards-modal-header">
    <h4 class="modal-title text-truncate">Time Leaving Parade Ring for {{ race.raceDatetime | date:'h:mm a' }}</h4>
    <button type="button" class="stewards-modal-close" (click)="cancel('cancel')" aria-label="Close">
      <fa name="times"></fa>
    </button>
  </div>
  <div class="modal-body stewards-modal-body">
    <div *ngIf="meta.loading">
      <div class="row">
        <div class="col-12 text-center">
          <img src="assets/loader.svg" class="d-block ml-auto mr-auto" alt="spinner">
        </div>
      </div>
    </div>
    <div *ngIf="!meta.loading">
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label class="stewards-modal-label">Last horse left Parade Ring (HH:MM:SS): *</label>
            <ngb-timepicker name="leftParadeRingTime"
                            [(ngModel)]="time"
                            (ngModelChange)="onTimeChange()"
                            [seconds]="true"
                            [required]="true"
                            [meridian]="true"
            ></ngb-timepicker>
         </div>
          <!-- ACTIONS -->
          <div class="form-group mb-0">
            <label class="stewards-modal-label">Further comments:</label>
            <textarea class="form-control" name="action" [(ngModel)]="action"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!meta.loading">
    <div *ngIf="!meta.saving" class="modal-footer stewards-modal-footer">
      <button type="button" class="btn btn-outline-secondary stewards-modal-btn-close" (click)="cancel('cancel')">Close</button>
      <button type="button"
              class="btn btn-primary"
              (click)="paradeRingRaces.leftParadeRingTime ? update() : confirm()"
              [disabled]="formLeftParadeRing.invalid"
      >{{ paradeRingRaces.leftParadeRingTime ? 'Update' : 'Confirm' }}</button>
      <button type="button" class="btn btn-danger" (click)="deleteRace()" *ngIf="paradeRingRaces.leftParadeRingTime">Delete</button>
    </div>
    <div *ngIf="meta.saving" class="modal-footer stewards-modal-footer stewards-modal-footer-loading">
      <fa name="circle-o-notch" animation="spin"></fa>
    </div>
  </div>
</form>
